import { render, staticRenderFns } from "./BusinessAccountInfoForm.vue?vue&type=template&id=a2d25f48&scoped=true&"
import script from "./BusinessAccountInfoForm.vue?vue&type=script&lang=js&"
export * from "./BusinessAccountInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d25f48",
  null
  
)

export default component.exports